import { useEffect, useRef, useState } from 'react'
import { wsUrl } from '../../../api/scripts/tasks'

interface WsMessage {
  // 后端推送实际不带 type 字段，这里保持可选，消费方按 task_id 匹配
  type?: 'progress' | 'status' | 'error'
  task_id: string
  progress?: number
  status?: string
  message?: string
}

const MAX_RETRY_MS = 15000

export function useWebSocket(onMessage: (msg: WsMessage) => void) {
  const [connected, setConnected] = useState(false)
  const wsRef = useRef<WebSocket | null>(null)
  const onMessageRef = useRef(onMessage)
  onMessageRef.current = onMessage

  useEffect(() => {
    let closedByUnmount = false
    let retryMs = 1000
    let retryTimer: ReturnType<typeof setTimeout> | undefined

    const connect = () => {
      const ws = new WebSocket(wsUrl())
      wsRef.current = ws

      ws.onopen = () => {
        retryMs = 1000
        setConnected(true)
      }
      ws.onclose = () => {
        setConnected(false)
        wsRef.current = null
        if (!closedByUnmount) {
          // 指数退避重连；wsUrl() 每次重新读取 token，token 刷新后自动用新凭证
          retryTimer = setTimeout(connect, retryMs)
          retryMs = Math.min(retryMs * 2, MAX_RETRY_MS)
        }
      }
      ws.onerror = () => setConnected(false)
      ws.onmessage = (event) => {
        try {
          onMessageRef.current(JSON.parse(event.data))
        } catch {
          // ignore
        }
      }
    }

    connect()

    return () => {
      closedByUnmount = true
      if (retryTimer) clearTimeout(retryTimer)
      wsRef.current?.close()
      wsRef.current = null
    }
  }, [])

  return { connected }
}
